import { Header } from "@/components/quiz/explainers/header";
import { Button } from "@workspace/ui/components/button";
import Image from "next/image";

export function FertilityTransitionsExplainer2({
  title,
  image,
  image_description,
  handleNext,
  sub_description,
}: {
  title: string;
  image: string;
  image_description: string;
  handleNext: () => void;
  sub_description: string;
}) {
  return (
    <>
      <div className="flex flex-1 flex-col gap-6 overflow-y-auto min-h-0 pb-12">
        <Header title={title} />
        <div className="bg-[#F6F6FA] rounded-[16px]">
          <div className="relative h-[300px] md:h-[400px]  w-full">
            <Image
              src={image}
              fill
              alt={image_description}
              className="object-contain"
            />
          </div>
          <p className="text-primary title-12 p-4"
          id="question-sub-title"
          data-testid="question-sub-title"
          >
            {image_description}
          </p>
        </div>
      </div>
      <div className="sticky bottom-0 flex flex-col gap-3 pb-6 bg-white">
        <p className="text-[#7F8598] text-center title-12"
        id="hint-text"
        data-testid="hint-text">
          {sub_description}
        </p>

        <Button onClick={handleNext} variant="default" className="w-full">Tell me more</Button>
      </div>
    </>
  );
}
